import { render, staticRenderFns } from "./ArchivedDancers.vue?vue&type=template&id=3cddf966&scoped=true&"
import script from "./ArchivedDancers.vue?vue&type=script&lang=js&"
export * from "./ArchivedDancers.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedDancers.vue?vue&type=style&index=0&id=3cddf966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cddf966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cddf966')) {
      api.createRecord('3cddf966', component.options)
    } else {
      api.reload('3cddf966', component.options)
    }
    module.hot.accept("./ArchivedDancers.vue?vue&type=template&id=3cddf966&scoped=true&", function () {
      api.rerender('3cddf966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/ArchivedDancers.vue"
export default component.exports